import { Button, Form, Modal, Input } from 'antd';
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconRevise from '../../../../../assets/Images/icons/icon-revise';
import useNotify from '../../../../../context/Notification/useNotify';
import DataFlowService from '../../../../../services/DataFlow.service';
import { ROUTER } from '../../../../../constants/router';

const ModalRevise = ({
    open,
    handelClose,
    getInventoryDataFlowInfo,
    status,
    department,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    let { businessProcessId } = useParams();
    const notify = useNotify();
    let navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            businessProcessId,
            status,
            lastReviewDate: null,
            nextReviewDue: null,
            ...values,
        };
        try {
            const { data } = await DataFlowService.changeStatusDataFlow(
                payload
            );
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully save data'),
                });
                setLoading(false);
                handelClose();
                getInventoryDataFlowInfo();
                navigate(
                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view`
                );
            } else {
                setLoading(false);
                handelClose();
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
            form.resetFields();
        } catch (error) {
            console.log(error);
            setLoading(false);
            handelClose();
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };

    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div
                className="text-4xl mb-6 "
                style={{ color: '#A8A8AF', textAlign: 'center' }}
            >
                <IconRevise />
            </div>
            <div className="text-2xl font-semibold pb-2 text-center ">
                {t('Revise')}
            </div>
            <div className="text-center text-[#65707A] whitespace-pre-line pb-4">
                {t('DataFlowReviseDesc', { department: department })}
            </div>
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item
                    name="reason"
                    rules={[
                        {
                            required: true,
                            message: t('dataFlow.ReasonIsRequired'),
                        },
                    ]}
                    label={t('Reason')}
                >
                    <Input.TextArea
                        maxLength={500}
                        showCount
                        rows={4}
                        placeholder={t(
                            'Please include a message to notify the data owner'
                        )}
                    />
                </Form.Item>

                <div className="flex justify-center items-center space-x-4 pt-12">
                    <Button
                        className="w-36"
                        type="primary"
                        onClick={handelClose}
                        size="large"
                        ghost
                        htmlType="reset"
                    >
                        {t('common.Cancel')}
                    </Button>

                    <Button
                        className="w-36"
                        loading={loading}
                        size="large"
                        type="primary"
                        htmlType="submit"
                    >
                        {t('common.Submit')}
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};
export default ModalRevise;
